import { useEffect, useState } from 'react';
import api from '../services/api';

// Several nav entry points link to an element page with the generic key (e.g.
// "management_control") whatever the company's sector. A sector exposes exactly one
// of an element's variants, so ask the backend's list_elements which one is valid.
// Returns null until resolved. Keys outside `variants` (e.g. employment_equity) pass through.
export const useSectorElementKey = (requestedKey, variants) => {
  const [elementKey, setElementKey] = useState(null);
  const variantList = variants.join('|');

  useEffect(() => {
    if (!variants.includes(requestedKey)) {
      setElementKey(requestedKey);
      return undefined;
    }
    let cancelled = false;
    api.get('/core/scorecard/list_elements/')
      .then((res) => {
        const available = new Set(res.data.flatMap((group) => group.elements));
        if (!cancelled) setElementKey(variants.find((v) => available.has(v)) || requestedKey);
      })
      .catch(() => { if (!cancelled) setElementKey(requestedKey); });
    return () => { cancelled = true; };
    // variants is described fully by variantList
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestedKey, variantList]);

  return elementKey;
};
